import * as React from 'react';
import {
    DateField,
    Show,
    SimpleShowLayout,
    TextField,
    useShowContext,
} from 'react-admin';
import { WrappedWithBackButton } from '../../common/wrapped-with-back-button';
import { Box } from '@mui/material';
import { CustomLabel } from '../../common/custom-label';
import { useTheme } from '@mui/material/styles';

export const UniqueRequestTemplateShowLayout = () => {
    const theme = useTheme();
    const { error, isLoading, record } = useShowContext();

    if (isLoading || record === null) {
        return <div>Betöltés...</div>;
    }
    if (error) {
        return <div>Hiba történt!</div>;
    }

    return (
        <SimpleShowLayout>
            <TextField source="id" label={'Id'} />
            <DateField
                source="createdAt"
                locales={['hu-HU']}
                label={'Létrehozva'}
                showTime
            />
            <DateField
                source="updatedAt"
                locales={['hu-HU']}
                label={'Módosítva'}
                showTime
            />
            <TextField source="name" label={'Elnevezés'} />
            <CustomLabel>Tartalom</CustomLabel>
            <Box
                sx={{
                    width: {
                        xs: '95%',
                        md: '20%',
                    },
                    padding: 2,
                    fontSize: 14,
                    backgroundColor:
                        theme.palette.mode === 'dark'
                            ? theme.palette.grey['300']
                            : theme.palette.grey['100'],
                    borderRadius: 1,
                    color: theme.palette.grey['800'],
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                }}
            >
                {record.content}
            </Box>
        </SimpleShowLayout>
    );
};

export const UniqueRequestTemplateShow = () => {
    return (
        <WrappedWithBackButton redirect={'/unique-request-template'}>
            <Show title={'Bejelentésüzenet sablon'}>
                <UniqueRequestTemplateShowLayout />
            </Show>
        </WrappedWithBackButton>
    );
};
